/* tslint:disable */
import {
  Patient,
  PatientNotificationChain
} from '../index';

declare var Object: any;
export interface PatientNotificationChainMappingInterface {
  "triggers": any;
  "creatorId": string;
  "id"?: any;
  "patientId"?: any;
  "created"?: Date;
  "chainId"?: any;
  patient?: Patient;
  patientNotificationChain?: PatientNotificationChain;
}

export class PatientNotificationChainMapping implements PatientNotificationChainMappingInterface {
  "triggers": any;
  "creatorId": string;
  "id": any;
  "patientId": any;
  "created": Date;
  "chainId": any;
  patient: Patient;
  patientNotificationChain: PatientNotificationChain;
  constructor(data?: PatientNotificationChainMappingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PatientNotificationChainMapping`.
   */
  public static getModelName() {
    return "PatientNotificationChainMapping";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PatientNotificationChainMapping for dynamic purposes.
  **/
  public static factory(data: PatientNotificationChainMappingInterface): PatientNotificationChainMapping{
    return new PatientNotificationChainMapping(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PatientNotificationChainMapping',
      plural: 'PatientNotificationChainMappings',
      path: 'PatientNotificationChainMappings',
      idName: 'id',
      properties: {
        "triggers": {
          name: 'triggers',
          type: 'any'
        },
        "creatorId": {
          name: 'creatorId',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "patientId": {
          name: 'patientId',
          type: 'any'
        },
        "created": {
          name: 'created',
          type: 'Date',
          default: new Date(0)
        },
        "chainId": {
          name: 'chainId',
          type: 'any'
        },
      },
      relations: {
        patient: {
          name: 'patient',
          type: 'Patient',
          model: 'Patient',
          relationType: 'belongsTo',
                  keyFrom: 'patientId',
          keyTo: 'id'
        },
        patientNotificationChain: {
          name: 'patientNotificationChain',
          type: 'PatientNotificationChain',
          model: 'PatientNotificationChain',
          relationType: 'belongsTo',
                  keyFrom: 'chainId',
          keyTo: 'id'
        },
      }
    }
  }
}
